// Components
import DropdownInput from "components/inputs/dropdown"
import NumberInput from "components/inputs/number"
import { CashFlowReport_s } from 'components/property/reports/report-styles'
// Data
import api_match from 'data/interface/api'
import propertyService from 'data/property'
import recoveryPoolService, { RecoveryPool } from 'data/recovery-pools'
import propertyReportService from "data/reports-property"
import _ from 'lodash'
import calcService from "data/calc"
import React, { FC, useEffect, useState } from "react"
// Styles
import { ButtonWithPress_s, Label_s } from "styles/app-styles"
import { ReportForm_s } from "styles/report-styles"
import RecoveryPoolGrid from "./recovery-pool-grid"

interface RecoveryPoolAuditProps {
  property: object
}

function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => value + 1); // update the state to force render
}

const RecoveryPoolAudit: FC<RecoveryPoolAuditProps> = (props) => {
  const startDateOptions = propertyReportService.getDateRanges('Recovery Pool Audit')
  const [data, setData] = useState<object[]>([])
  const [start_year, setStartMonth] = useState<string>(startDateOptions[0])
  const [term, setTerm] = useState<number>(propertyReportService.getReportTermDefault())
  const [recoverypools, setRecoveryPools] = useState<object[]>([]);
  const forceUpdate = useForceUpdate();

  useEffect(() => {
    setTerm(propertyReportService.getReportTermDefault());
    recoveryPoolService.fetchRecoveryPools(propertyService.getStoredPropertyId())
  }, [props['property']])

  function submit():void {
    propertyReportService.propertyReport({
      report: 'recovery_pool_audit',
      params: {
        recoverypools: recoverypools.map(pool => pool['recoverypoolid']),
        start_year: start_year.slice(-4),
        term
      }
    });
  }

  function updateTerm(field:string, val:number):void {
    let validated = propertyReportService.validateStartYear(start_year, val, {
      start_year: start_year.slice(-4),
      term
    }, startDateOptions)
    if (validated !== -1) setTerm(validated)
    else setTerm(val)
    forceUpdate();
  }

  function updateDate(val:string):void {
    let validated = propertyReportService.validateStartYear(val, null, {
      start_year: start_year.slice(-4),
      term
    }, startDateOptions)
    setStartMonth(val)
    if (validated !== -1) setTerm(validated)
  }

  useEffect(() => {
    const recoveryPoolSubscription = recoveryPoolService.stream().subscribe(data => {
      api_match(
        data,
        init  => {
          let pools = init.value
          pools.push({recoverypoolid: -1, code: "AllRecoverable", name: "AllRecoverableExpenses"} as RecoveryPool)
          setData(pools);
          setRecoveryPools(pools);
        },
        ok    => {
          let pools = ok.value
          pools.push({recoverypoolid: -1, code: "AllRecoverable", name: "AllRecoverableExpenses"} as RecoveryPool)
          setData(pools);
          setRecoveryPools(pools);
        },
        err   => {
          setData(err.value)
        },
        fetch => {}
      )
    })
    return function cleanup() {
      recoveryPoolSubscription.unsubscribe()
    }
  }, [])

  const disabled = !calcService.calcCheck(props.property)
  const buttonText = disabled ? 'Calculation Required' : 'Run Report'

  return (
    <CashFlowReport_s>
      <ButtonWithPress_s primary onClick={submit} style={{marginBottom: 20}} disabled={disabled}>{buttonText}</ButtonWithPress_s>
      <ReportForm_s>
        <div>
          <Label_s>Start Date</Label_s>
          <DropdownInput
            className="start-year-input"
            persist={(field:string, val:string)=>updateDate(val)}
            field="start_year"
            options={startDateOptions.map(opt => { return { label: opt, value: opt }})}
            value={start_year}
          />
        </div>
        <div>
          <Label_s>Term</Label_s>
          <NumberInput
            field="start_year"
            value={term}
            persist={(val, field) => updateTerm(val, field)}
            readPrecision={0}
            writePrecision={0}
          />
        </div>
      </ReportForm_s>
      <ReportForm_s>
        <RecoveryPoolGrid data={data} selected={recoverypools} setSelected={setRecoveryPools} />
      </ReportForm_s>
    </CashFlowReport_s>
  )
}

export default RecoveryPoolAudit
